import { Typography } from '@paddle/ant-component-library'
import styled from 'styled-components'

export const Title = styled(Typography.Text)`
  font-size: 20px;
  line-height: 36px;
  margin-bottom: 20px;
  display: block;
`
